var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { getReportExport, postReportsExportBundle, } from "@piiqtechnologies/ui-lib";
import { DownloadMode, ExportFormat } from "@constants/Export";
export const toApiFormat = (format) => (format === ExportFormat.Csv ? "csv" : "pdf");
const requestSingleExport = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (!payload.assessmentId)
        throw new Error("Export requires an assessmentId");
    const response = yield getReportExport(payload.assessmentId, toApiFormat(payload.format));
    const typed = response;
    const data = typed === null || typed === void 0 ? void 0 : typed.data;
    if (!(data === null || data === void 0 ? void 0 : data.url))
        throw new Error("Export response missing url");
    return { url: data.url, fileName: data.fileName };
});
const requestBundleExport = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const response = yield postReportsExportBundle({
        subjectIds: payload.communityIds,
        format: toApiFormat(payload.format),
    });
    const typed = response;
    const data = typed === null || typed === void 0 ? void 0 : typed.data;
    if (!(data === null || data === void 0 ? void 0 : data.url))
        throw new Error("Export response missing url");
    return {
        url: data.url,
        fileName: data.fileName,
        included: data.included,
        skippedSubjectIds: (_a = data.skippedSubjectIds) !== null && _a !== void 0 ? _a : [],
    };
});
export const requestReportExport = (payload) => payload.mode === DownloadMode.Single ? requestSingleExport(payload) : requestBundleExport(payload);
export const useRequestReportExport = () => useCallback((payload) => requestReportExport(payload), []);
